import React from "react";
import { Box, Typography } from "@mui/material";

export default function FeatureDisabled() {
  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="60vh">
      <Typography variant="h5" color="textSecondary" align="center" gutterBottom>
        This Generative AI feature has been disabled at the request of this publisher.
      </Typography>
      <Typography variant="body1" color="textSecondary" align="center">
        We apologize for the inconvenience but it's critical we protect the intellectual property rights of content owners.
      </Typography>
    </Box>
  );
}
